<template>
  <el-card
      class="item-card"
      shadow="never"
      style="border-radius: 4px !important; border: 1px solid #dee5ec;background-color:rgb(250, 251, 252); "
      body-style="margin: 0px;">
    <div
        class="item-names"
        style="margin: 8px 24px 24px 8px">
      <p>The {{ totalShipments+1 }}{{ numberSuffix }} shipment info will be available soon</p>
    </div>
  </el-card>
</template>
<script>
export default {
  name: "ShippingDetailsNotAvailable",
  props: {
    totalShipments: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    numberSuffix() {
      return "th,st,nd,rd,th,th,th,th,th,th".split(",")[
        (this.totalShipments + 1) % 10
      ];
    },
  },
};
</script>

<style>
.item-names {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
  color: #81919f;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  text-align: center;
}

.item-asin {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: flex-end;
  color: #6e6e6e;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  margin-top: 2px;
}
</style>
